"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _loyaltyDialogContext = require("./loyaltyDialogContext");
Object.keys(_loyaltyDialogContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _loyaltyDialogContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _loyaltyDialogContext[key];
    }
  });
});
